import { HeaderSubjects } from '@logz-pkg/enums';
import { Box, Flex, Group, Header } from '@logz-ui/styleguide';
import { FunctionComponent } from 'react';
import { SelectAccountButton } from './AccountSelector/SelectButton';
import { HeaderBreadcrumbs } from './HeaderBreadcrumbs';
import { HelpMenu } from './HelpMenu';
import { OrionIqTrigger } from 'ui/components/OrionChat/OrionIqTrigger';
import { useIsOrionChatAccount } from 'ui/components/OrionChat/use-orion-chat-gates.hook';
import { useGuidedWalkthrough } from 'ui/state/hooks/guided-walkthrough.state.hook';
import { GuidedWalkthroughBadge } from 'ui/components/GuidedWalkthrough/Components/WalkthroughHeaderBadge';

export const NavigationHeader: FunctionComponent = () => {
  const { isActivated: isGuidedWalkthroughActivated } = useGuidedWalkthrough();
  const isOrionChatAccount = useIsOrionChatAccount();

  return (
    <Header py={2} justifyContent={'center'} pr={3} pl={8} flexDirection={'column'} subject={HeaderSubjects.Header}>
      <Flex width={'100%'} justifyContent={'space-between'}>
        <HeaderBreadcrumbs />
        <Box />
        <Group gap={4} alignItems={'center'}>
          <Group gap={0} alignItems={'center'} subject={HeaderSubjects.HeaderActions}>
            {isGuidedWalkthroughActivated ? <GuidedWalkthroughBadge /> : null}
            <HelpMenu />
            {isOrionChatAccount ? <OrionIqTrigger /> : null}
          </Group>
          <SelectAccountButton />
        </Group>
      </Flex>
    </Header>
  );
};
